import React from 'react'

export const ProductFeature = ({
    isGray,
    title,
    description,
    imageURL,
    isFirst,
}) => {
    const getItem = () => {
        if (isGray) {
            return (
                <>
                    <div className="grid-column-start-1 grid-column-end-8 grid-column-tablet-start-1 grid-column-tablet-end-7 grid-column-mobile-start-1 grid-column-mobile-end-5">
                        <h2 className="h2 u-padding-top-xlarge">{title}</h2>
                    </div>
                    <div className="grid-column-start-5 grid-column-end-13 grid-column-tablet-start-5 grid-column-tablet-end-9 grid-column-mobile-start-1 grid-column-mobile-end-5">
                        <img
                            src={imageURL}
                            alt=""
                            className="u-image-full u-padding-top-medium u-padding-bottom-medium"
                        />
                    </div>
                    <div className="grid-column-start-1 grid-column-end-8 grid-column-tablet-start-1 grid-column-tablet-end-5 grid-column-mobile-start-1 grid-column-mobile-end-5">
                        <p className="paragraph paragraph--big">
                            {description}
                        </p>
                    </div>
                </>
            )
        }

        return (
            <>
                <div className="grid-column-start-5 grid-column-end-13 grid-column-tablet-start-1 grid-column-tablet-end-7 grid-column-mobile-start-1 grid-column-mobile-end-5">
                    <h2 className="h2 u-padding-top-xlarge">{title}</h2>
                </div>
                <div className="grid-column-start-1 grid-column-end-8 grid-column-tablet-start-1 grid-column-tablet-end-5 grid-column-mobile-start-1 grid-column-mobile-end-5">
                    <img
                        src={imageURL}
                        alt=""
                        className="u-image-full u-padding-top-medium u-padding-bottom-medium"
                    />
                </div>
                <div className="grid-column-start-5 grid-column-end-13 grid-column-tablet-start-5 grid-column-tablet-end-9 grid-column-mobile-start-1 grid-column-mobile-end-5">
                    <p className="paragraph paragraph--big">{description}</p>
                </div>
            </>
        )
    }

    return (
        <section
            className={`${isGray ? 'section--gray' : ''} ${
                isFirst ? 'u-display-none' : ''
            } section grid section--pim`}
        >
            <div className="grid-container grid">{getItem()}</div>
        </section>
    )
}
